export default __webpack_public_path__ + "static/media/hh0.73c51b54.png";